"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCommercialRuleSchema = exports.createCommercialRuleSchema = exports.COMMERCIAL_RULE_TYPES = void 0;
const zod_1 = require("zod");
exports.COMMERCIAL_RULE_TYPES = [
    'PERCENTAGE_OFF_MRP',
    'PERCENTAGE_OFF_SELLING_PRICE',
    'MRP',
    'COST_PLUS_PERCENT',
    'FIXED_RATE',
    'ZERO_COST',
];
exports.createCommercialRuleSchema = zod_1.z.object({
    ruleCode: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    ruleType: zod_1.z.enum(exports.COMMERCIAL_RULE_TYPES),
    ruleValue: zod_1.z.number().optional(),
    priority: zod_1.z.number().int().optional(),
});
exports.updateCommercialRuleSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(255).optional(),
    ruleType: zod_1.z.enum(exports.COMMERCIAL_RULE_TYPES).optional(),
    ruleValue: zod_1.z.number().optional(),
    priority: zod_1.z.number().int().optional(),
});
//# sourceMappingURL=commercial-rule.schema.js.map